import * as React from "react"
import UserInterfaceIcon from "@/components/UserInterfaceIcon"
import HoverCard from "@/components/HoverCard"
import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import findImage from "@/utils/find-image"

export const ActionSteps = ({ children }) => {
  const steps = Array.isArray(children) ? children : [children]

  return (
    <span className="action-steps">
      {steps.map((step, index) => {
        const isLastStep = index === steps.length - 1

        if (isLastStep) {
          return step
        }

        return (
          <React.Fragment key={step.props.text}>
            {step}

            <span className="action-steps__arrow">
              <UserInterfaceIcon src="arrow-right" />
            </span>
          </React.Fragment>
        )
      })}
    </span>
  )
}

export const ActionStep = ({ text, icon, hoverImage }) => {
  if (icon) {
    return (
      <span className="action-steps__step">
        <UserInterfaceIcon src={icon} />

        <span className="action-steps__step-text">{text}</span>
      </span>
    )
  }

  if (hoverImage) {
    return (
      <HoverCard className="action-steps__step" image={hoverImage}>
        {text}
      </HoverCard>
    )
  }

  return <span className="action-steps__step">{text}</span>
}

export default ActionSteps
